/**
 * Window Functions which are used in the Vue apps.
 * Such as .sortable(), which can only sort once the DOM has loaded, which needs to be done in eg Vue.updated since the DOM is loaded dynamically.
 */

require('./partials/resize.js');
require('./partials/networking.js');
require('./partials/i18n.js');
require('./partials/aside.js');
require('./partials/validator.js');
require('./partials/loader.js');
require('./partials/dateformatter.js');
// require('./partials/sizes.js');
require('./partials/colors.js');
require('./partials/showToast.js');
require('./partials/digitgrouping.js');
require('./partials/errorHandler.js');

/* Partials JS */
require('./partials/polyfill.js');
require('./partials/collapse.js');
require('./partials/datepicker.js');
require('./partials/sortable.js');
require('./partials/sticky.js');
require('./partials/fixed.js');
require('./partials/filehelper.js');
require('./partials/toggleActive.js');
require('./partials/toggleClass.js');
require('./partials/toggleDropdown.js');
require('./partials/togglePassword.js');
require('./partials/slider.js');

/* Vue */
require('./vue/_vue-requires.js');
